<template>
  <div>
    <initial-loading :active="showInitialLoading"/>
    <div id="app" v-if="!load && (empresa?.status === '2' || franquiasEnabled)" :class="classes">
      <router-view/>
    </div>
    <status-empresa v-else-if="!load" :status="empresa?.status"/>

    <div class="modal modal-loading d-block" v-if="loadingGeral" style="z-index: 2090">
      <div class="modal-content border-0">
        <div style="padding: 24px 0 32px">
          <loading :text="loadingGeral"/>
        </div>
      </div>
    </div>

    <onesignal v-if="!load"/>
    <modal-instagram v-if="!load"/>

  </div>
</template>

<script>
import Loading from "../../components/Loading";
import InitialLoading, { initialLoadingMixin } from "../../components/InitialLoading";
import StatusEmpresa from "../../components/StatusEmpresa";
import ModalInstagram from "../../components/ModalInstagram";
import Onesignal from "../../components/OneSignal";

export default {
  name: 'App',
  mixins: [initialLoadingMixin],
  components: {InitialLoading, Onesignal, StatusEmpresa, ModalInstagram, Loading},
  data() {
    return {
      load: true,
      user: {},
      token: '',
      empresa: { status: '2' },
      classes: ''
    }
  },

  methods: {
    normalizarTelefoneZap(telefone) {
      let telefoneNormalizado = ((telefone || '') + '').replace(/\D/g, '');

      if (telefoneNormalizado.length > 11 && telefoneNormalizado.startsWith('55')) {
        telefoneNormalizado = telefoneNormalizado.substring(2);
      }

      return telefoneNormalizado;
    },

    salvarDadosZapHash() {
      const hash = ((this.$route.query.m || '') + '').trim();

      if (!hash) {
        return;
      }

      if (this.token) {
        return;
      }

      this.$http.get(`zap/${encodeURIComponent(hash)}`)
        .then(response => {
          const dados = response?.data?.dados || {};
          const nome_cliente = (dados.nome_user ? dados.nome_user : '').trim();
          const telefone = this.normalizarTelefoneZap(dados.telefone);

          if (!nome_cliente && !telefone) {
            return;
          }

          sessionStorage.setItem('utm_source', 'whatsapp');
          sessionStorage.setItem('zapHashData', JSON.stringify({ hash, nome_cliente, telefone }));
        }, () => {})
    },

    getEmpresa(dominio, sacola, callback) {
      if (!dominio) {
        this.load = false;

        if (this.$route.name !== 'NotFound') {
          this.$router.push({ path: '/404', replace: true });
        }

        return;
      }

      const tipo_pedido = sacola ? sacola.tipo_pedido : null;
      this.$http.get('v2/empresa', { params: { dominio, tipo_pedido } }).then(response => {
        if (response.data && response.data.empresa && response.data.empresa.id_empresa) {
          this.empresa = response.data.empresa;
          this.empresa.server = this.server;
          this.$store.commit('setEmpresa', this.empresa);

          if (!this.is_plus) {
            this.setColor(this.empresa.theme_color);
          }

          this.$store.commit('setCardapio', response.data);
          this.$store.state.url = this.$helpers.getUrlApp(this.$route.params.id || '');
          this.classes += ` theme-${this.empresa.id_theme}`;
          this.$helpers.setEmpresaStatus(this, this.empresa, () => {
            if (sacola && (!sacola.token || sacola.token === this.empresa.token) && sacola.expiracao > (new Date().getTime())) {

              if (!this.empresa.json_config.nolocal) {
                localStorage.removeItem('nolocal');
                sacola.nolocal = '';
                sacola.tipo_pedido = '1';
                sacola.origin = this.origin;
              }

              this.$store.state.sacola = sacola;
              this.$store.commit('setProdutosSacola', sacola);

            } else {
              // TODO buscar os produtos novamente caso o tipo_pedido for 3
              localStorage.removeItem('sacola');
              localStorage.removeItem('nolocal');
            }

            this.$helpers.configGoogleTag(this)

            if (this.empresa.gmaps_public_key) {
              this.$store.state.placesUnavailable = false;
              this.$googleMaps.init(this.empresa.gmaps_public_key).catch((err) => {
                this.$store.state.placesUnavailable = true;
                console.warn('Falha ao inicializar Google Maps', err);
              });
            }

            if (callback) { callback() }
          });

        } else {
          this.tratarErroEmpresa(response?.data?.status);
        }

      }, res => {
        this.tratarErroEmpresa(res?.data?.status);
      });
    },

    tratarErroEmpresa(status) {
      if (this.franquiasEnabled) {
        this.$swal('Não conseguimos acessar essa unidade. Tente novamente.');

        if (this.$route.name !== 'Home') {
          this.$router.push({ path: '/', replace: true });
        }

      } else {
        this.empresa.status = status || '1';
      }

      this.load = false;
    },

    autenticar() {
      if (!this.token) {
        this.load = false;
        return;
      }

      const dados = { token: this.token };

      if (this.franquiasEnabled) {
        dados.id_unidade = this.empresa.id_empresa;
      }

      this.$http.post(this.empresa.token + '/login', dados)
        .then(res => {
          if (res && res.data.success) {
            this.user = res.data.dados;
            this.$store.commit('setDataUser', res.data);
            const id_cliente = this.user.id_cliente;

            if (this.oneSignalIntegration) {
              setTimeout(() => {
                if (this.$OneSignal) {
                  this.$OneSignal.isPushNotificationsEnabled().then(isEnabled => {
                    if (isEnabled) {
                      this.$OneSignal.setExternalUserId(id_cliente).then(res => {
                        this.$http.post(this.empresa.token + '/' + this.token + '/cliente/onesignal', { push_habilitado: '1' }).then(res => {});
                      });
                    }
                  });
                }
              }, 5000);
            }

            this.setSentry({ email: this.user.email });
            this.load = false;
          }

        }, res => {
          this.load = false;
          let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
          this.$swal(msg).then(() => {
            this.$store.commit('logout');

            if (res.status === 401 && this.$route.meta.page !== 'Home') {
              this.$router.push('/');
            }
          });
        });
    },

    getSacola() {
      const sacolaTemp = this.$helpers.parseJSONObject(localStorage.getItem('sacola'));
      const nolocal = this.$helpers.parseJSONObject(localStorage.getItem('nolocal'));

      if (nolocal && (nolocal.expiracao > new Date().getTime())) {
        let sacola = sacolaTemp || { produtos: [], expiracao: nolocal.expiracao };
        sacola.origin = '4';
        sacola.tipo_pedido = nolocal.tipo_pedido || '2';
        this.$store.state.nolocal = nolocal;
        return sacola;

      } else if (sacolaTemp && sacolaTemp.origin !== '4') {
        sacolaTemp.expiracao = sacolaTemp.expiracao || new Date().getTime() + ((1000 * 60 * 60) * 24);
        return sacolaTemp;
      }

      localStorage.removeItem('sacola');
      localStorage.removeItem('nolocal');
      return null;
    },

    setColor(color) {
      if (color) {
        document.documentElement.style.setProperty('--lecard-primary', color);
        document.documentElement.style.setProperty('--lecard-secondary', color);
      }

      // document.title = `${this.empresa.nome_fantasia} | LeCard`;
    },

    beforeInstallHandler(e) {
      e.preventDefault();
      this.$store.commit('setPrompt', e);
    },

    initApp() {
      this.classes = this.ios_installed ? 'ios_platform' : 'android_platform';
      this.token = localStorage.getItem("token") || false;
      this.$store.state.isFranquia = !!this.franquiasEnabled;
      this.salvarDadosZapHash();

      if (this.$route.query.cupom) {
        localStorage.setItem('ref_cupom', this.$route.query.cupom || '');
      }

      const routes = ['Home','NoLocal'];

      if (this.franquiasEnabled && routes.includes(this.$route.name)) {
        this.load = false;

      } else {
        const sacola = this.getSacola();
        let dominio = this.franquiasEnabled ? (this.$route.params.id || null) : this.dominio;

        if (!this.franquiasEnabled && this.$route.path.startsWith('/unidade')) {
          dominio = null;
        }

        this.getEmpresa(dominio, sacola, () => {
          this.autenticar();
        });
      }
    }
  },

  mounted() {
    console.log('Current version: ' + this.app_version);
    sessionStorage.removeItem('cuponsReadonly');

    if (this.android_installed) {
      sessionStorage.setItem('android-app', 'true');
    }

    if (this.is_plus) {
      this.initApp();

    } else {
      setTimeout(() => {
        this.initApp();
      }, 1500);
    }
  },

  created() {
    window.addEventListener('beforeinstallprompt', this.beforeInstallHandler);
  },

  computed: {
    loadingGeral() {
      return this.$store.state.load;
    }
  },

  beforeDestroy() {
    window.removeEventListener('beforeinstallprompt', this.beforeInstallHandler);
  }
}
</script>

<style>
</style>
